import {Component, Inject, OnInit} from '@angular/core';
import {Localiser} from "../../../services/localiser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { saveAs } from 'file-saver';
import {luminaria} from "../../../models/luminaria";
import {proyecto} from "../../../models/proyecto";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";
import {sensor} from "../../../models/sensor";
import {LuminariaService} from "../../../services/luminaria.service";
import {UserService} from "../../../services/user.service";
import {SensorService} from "../../../services/sensor.service";

interface lum {
  mac: string,
  name: string,
  project: string,
  floorplan: string,
  version: string,
  power: number,
  sn: string,
  led: string,
  lumen: number
}

interface sens {
  mac: string,
  name: string
}

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.css']
})
export class OptionsComponent implements OnInit {

  csvFilePage = false;
  csvFilePageDownload = false;
  devicesToInsertPage = false;
  csvOfLuminaries = true;

  luminariesHeader = ["MAC", "Name", "Project name", "Floorplan name", "Version", "Power_consumption", "S/N", "Model_led", "Lumen"].join(',');
  sensorsHeader = ["MAC", "Name"].join(',');
  errorMessage = "";

  devicesToInsert = [];
  updating = false;

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<OptionsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {luminaries: luminaria[], projects: proyecto[], floorplans: plano[],
                sensors: sensor[]}, private luminariaService: LuminariaService, private sensorService: SensorService,
              private user: UserService) { }

  ngOnInit(): void {

  }

  changeCsvToLuminaries(bool: boolean) {
    this.csvOfLuminaries = bool;
    this.errorMessage = "";
  }

  downloadTemplate(luminaries: boolean) {
    let header, content, title;
    if (luminaries) {
      header = this.luminariesHeader;
      content = "1E3B9EFEFF756A62,luminary_name,project_name,floorplan_name,0.0,0,serial_number,0.0,0";
      title = "luminaries_template.csv";
    } else {
      header = this.sensorsHeader;
      content = "1E3B9EFEFF756A62,sensor_name";
      title = "sensors_template.csv";
    }
    let blob = new Blob([header + "\r\n" + content], {type: 'text/csv'})
    saveAs(blob, title);
  }

  onSelectFile(event) {
    this.errorMessage = "";
    let file: File = event.target.files[event.target.files.length - 1] as File;
    if(file) {
      let reader: FileReader = new FileReader();
      reader.readAsText(file, 'ISO-8859-1');
      reader.onload = (e) => {
        this.checkCSVEntry(reader.result as string);
      }
    }
  }

  checkCSVEntry(csv: string) {
    this.devicesToInsert = [];
    let csvRows = csv.split("\r\n");
    let headers = csvRows[0];

    if (this.csvOfLuminaries) {
      if (this.luminariesHeader != headers) {
        this.errorMessage = this.localiser.get("uploadCSV.errorHeaders");
      } else {
        for (let i = 1; i < csvRows.length; i++) {
          if (csvRows[i] != undefined && csvRows[i] != "" && csvRows[i].length != 0) {
            let row = csvRows[i].split(",");
            let lum: lum = {
              mac: row[0],
              name: row[1],
              project: row[2],
              floorplan: row[3],
              version: row[4],
              power: +row[5] || 0,
              sn: row[6],
              led: row[7],
              lumen: +row[8] || 0
            }

            let project = this.data.projects.find(pro => pro.nombre == lum.project);
            let floorplan = this.data.floorplans.find(flo => flo.nombre == lum.floorplan);
            if (project != undefined) {
              lum.project = project.idProyecto;
              if (floorplan != undefined && floorplan.idProyecto == project.idProyecto) {
                lum.floorplan = floorplan.idPlano;
              } else {
                lum.floorplan = "-1";
              }
            } else {
              lum.project = "-1";
              lum.floorplan = "-1";
            }
            if (lum.mac.length > 50) {
              lum.mac = "--";
            }
            if (lum.name.length > 50) {
              lum.name = "--";
            }
            if (lum.version.length > 10) {
              lum.version = "--";
            }
            if (lum.power.toString().length > 10) {
              lum.power = 0;
            }
            if (lum.sn.length > 50) {
              lum.sn = "0";
            }
            if (lum.led.length > 50) {
              lum.led = "0";
            }
            if (lum.lumen.toString().length > 10) {
              lum.lumen = 0;
            }

            this.devicesToInsert.push(lum);
          }
        }
      }
    } else {
      if (this.sensorsHeader != headers) {
        this.errorMessage = this.localiser.get("uploadCSV.errorHeaders");
      } else {
        for (let i = 1; i < csvRows.length; i++) {
          if (csvRows[i] != undefined && csvRows[i] != "" && csvRows[i].length != 0) {
            let row = csvRows[i].split(",");
            let sens: sens = {
              mac: row[0],
              name: row[1]
            }

            if (sens.mac.length > 50) {
              sens.mac = "--";
            }
            if (sens.name.length > 50) {
              sens.name = "--";
            }

            this.devicesToInsert.push(sens);
          }
        }
      }
    }

    if (this.errorMessage == "" && this.devicesToInsert.length > 0) {
      this.showDevicesToInsert();
    } else if (this.errorMessage == ""){
      this.errorMessage = this.localiser.get("uploadCSV.errorNoDevices");
    }

  }

  getProject(idProject: string) {
    let project = this.data.projects.find(pro => pro.idProyecto == idProject);
    if (project) {
      return project.nombre;
    } else {
      return "--";
    }
  }

  getFloorplan(idFloorplan: string) {
    let floorplan = this.data.floorplans.find(flo => flo.idPlano == idFloorplan);
    if (floorplan) {
      return floorplan.nombre;
    } else {
      return "--";
    }
  }

  lumAlreadyRegistered(idDispositivo: string) {
    return this.data.luminaries.find(lum => lum.idDispositivo == idDispositivo) != undefined;
  }

  sensorAlreadyRegistered(idDispositivo: string) {
    return this.data.sensors.find(sens => sens.idLuminaria == idDispositivo) != undefined;
  }

  showDevicesToInsert() {
    this.csvFilePage = false;
    this.csvFilePageDownload = false;
    this.devicesToInsertPage = true;
  }

  sendToInsert() {
    if (this.csvOfLuminaries) {
      this.sendLuminariesToInsert();
    } else {
      this.sendSensorsToInsert();
    }
  }

  sendLuminariesToInsert() {
    this.updating = true;
    this.luminariaService.addLuminariesFromCSV(this.user.getId(), this.devicesToInsert).subscribe(result => {
      this.updating = false;
      this.onConfirmAndSave();
    }, error => {
      this.updating = false;
      this.toCsvFilePage();
      this.errorMessage = this.localiser.get("uploadCSV.errorServer");
    })
  }

  sendSensorsToInsert() {
    this.updating = true;
    this.sensorService.addSensorsFromCSV(this.user.getId(), this.devicesToInsert).subscribe(result => {
      this.updating = false;
      this.onConfirmAndSave();
    }, error => {
      this.updating = false;
      this.toCsvFilePage();
      this.errorMessage = this.localiser.get("uploadCSV.errorServer");
    })
  }

  toCsvFilePage() {
    this.csvFilePage = true;
    this.csvFilePageDownload = false;
    this.devicesToInsertPage = false;
  }

  toCsvFilePageDownload() {
    this.csvFilePage = false;
    this.csvFilePageDownload = true;
    this.devicesToInsertPage = false;
  }

  toBackHome() {
    this.csvFilePage = false;
    this.csvFilePageDownload = false;
    this.devicesToInsertPage = false;
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmAndSave() {
    this.dialogRef.close(true);
  }

  downloadLuminariesCSV() {
    this.luminariaService.downloadLuminariesCSV().subscribe((csvContent: string) => {
      if (!csvContent) {
        console.error('No CSV data received.');
        return;
      }

      const header = this.luminariesHeader;
      const blob = new Blob([header + '\r\n' + csvContent], { type: 'text/csv;charset=utf-8' });
      saveAs(blob, 'luminarias.csv');
    });
  }

  downloadSensorsCSV() {
    this.sensorService.downloadSensorsCSV().subscribe((csvContent: string) => {
      if (!csvContent) {
        console.error('No CSV data received.');
        return;
      }

      const header = this.sensorsHeader;
      const blob = new Blob([header + '\r\n' + csvContent], { type: 'text/csv;charset=utf-8' });
      saveAs(blob, 'sensores.csv');
    });
  }

}
